var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.listaSetorVenda,"item-text":"nmSetorVenda","item-value":"cdSetorVenda","label":"Setor Venda","outlined":"","readonly":_vm.readonly,"hide-details":"","dense":_vm.dense},on:{"change":_vm.onSelectSetorVenda},model:{value:(_vm.cdSetorVenda),callback:function ($$v) {_vm.cdSetorVenda=$$v},expression:"cdSetorVenda"}})
}
var staticRenderFns = []

export { render, staticRenderFns }